import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import {
  ServiceCategories,
  Services as ServicesData,
  buildServiceWhatsAppUrl,
} from "@/data/SiteContent";

const AllFilter = { Id: "todos", Label: "Todos los servicios" };

export default function Services() {
  const [ActiveCategory, setActiveCategory] = useState(AllFilter.Id);
  const Filters = [AllFilter, ...ServiceCategories];
  const VisibleServices =
    ActiveCategory === AllFilter.Id
      ? ServicesData
      : ServicesData.filter((pService) => pService.CategoryId === ActiveCategory);

  return (
    <section id="servicios" className="scroll-mt-20 bg-white py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-16">
        <Reveal className="max-w-2xl">
          <p className="text-xs font-medium uppercase tracking-[0.3em] text-gold-dark">
            Servicios legales y notariales
          </p>
          <h2 className="mt-4 font-serif text-3xl tracking-tight text-ink sm:text-4xl">
            Nuestros servicios
          </h2>
          <p className="mt-5 text-base leading-relaxed text-ash">
            Le acompañamos en sus trámites legales y notariales con atención profesional y
            personalizada.
          </p>
        </Reveal>

        <div
          data-testid="services-category-tabs"
          role="tablist"
          aria-label="Categorías de servicios"
          className="mt-10 flex flex-wrap gap-3"
        >
          {Filters.map((pFilter) => (
            <button
              key={pFilter.Id}
              type="button"
              role="tab"
              aria-selected={ActiveCategory === pFilter.Id}
              data-testid={`service-tab-${pFilter.Id}`}
              onClick={() => setActiveCategory(pFilter.Id)}
              className={`border px-5 py-2.5 text-sm transition-colors duration-300 ${
                ActiveCategory === pFilter.Id
                  ? "border-gold bg-gold text-ink"
                  : "border-ink/15 text-ash hover:border-gold hover:text-gold-dark"
              }`}
            >
              {pFilter.Label}
            </button>
          ))}
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
          {VisibleServices.map((pService) => (
            <article
              key={pService.Id}
              data-testid={`service-card-${pService.Id}`}
              className="group flex h-full flex-col border border-ink/10 bg-white p-7 transition-all duration-300 hover:border-gold/60 hover:shadow-lg"
            >
              <div className="flex items-center gap-4">
                <img
                  src={pService.Image}
                  alt=""
                  aria-hidden="true"
                  loading="lazy"
                  width={56}
                  height={56}
                  className="duotone-thumb h-14 w-14 shrink-0 border border-gold/40 object-cover"
                />
                <span
                  className="font-serif text-2xl leading-none text-gold-dark"
                  aria-hidden="true"
                >
                  {String(pService.Id).padStart(2, "0")}
                </span>
                <div className="h-px flex-1 bg-gold/40" aria-hidden="true" />
              </div>
              <h3 className="mt-4 font-serif text-lg leading-snug text-ink">{pService.Title}</h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-ash">
                {pService.Description}
              </p>
              <a
                href={buildServiceWhatsAppUrl(pService.Title)}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={`service-whatsapp-button-${pService.Id}`}
                className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-gold-dark transition-colors duration-300 group-hover:text-gold"
              >
                <MessageCircle className="h-4 w-4" aria-hidden="true" />
                Consultar por WhatsApp
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
